import './search.scss';

(function($){

  $(function(){
    var search = $('.search-field').eq(0).val(),
      pattern = new RegExp(`(${search})`),
      replace = '<span class="found">$1</span>',
      $elems = $('.main-content-area').eq(0).find('.woocommerce-loop-product__title, .woocommerce-product-details__short-description, .entry-title a, .entry-summary');

    $elems.each(function(){
      var $elem = $(this),
          text = $elem.html();

      $elem.html( text.replace(pattern, replace) );
    });
  });

})(jQuery);
